import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import OrderNew from '@/views/order/OrderNew'
import OrderNewPkg from '@/views/order/OrderNewPkg'
import OrderDetail from '@/views/order/OrderDetail'
import ManageOrderList from '@/views/order/ManageOrderList'
import OrderNewSuccess from '@/views/order/OrderNewSuccess'

import MyOrderList from '@/views/customer/MyOrderList'
import OrderConfirm from '@/views/customer/OrderConfirm'
import OrderPaySuccess from '@/views/customer/OrderPaySuccess'
import OrderContract from '@/views/customer/OrderContract'
import OrderPurchaseDone from '@/views/customer/OrderPurchaseDone'
// import OrderServiceDone from '@/views/customer/OrderServiceDone'
import OrderSelectTeacher from '@/views/customer/OrderSelectTeacher' // 选择关注老师
import OrderServiceComplete from '@/views/customer/OrderServiceComplete' // 选择关注老师后完成
import OrderFullDetail from '@/views/customer/OrderFullDetail'
import NoQyServiceOrderDone from '@/views/customer/NoQyServiceOrderDone'

import TransAccounts from '@/views/payment/TransAccounts'
import TransQr from '@/views/payment/TransQr'
import TransFillIn from '@/views/payment/TransFillIn'
import TransList from '@/views/payment/TransList'
import TransEdit from '@/views/payment/TransEdit'

import Payways from '@/views/payment/Payways'
import PayOnline from '@/views/payment/PayOnline'
import PayQr from '@/views/payment/PayQr'

import MessageShow from '@/views/message/MessageShow'
import MobileVerify from '@/views/sms/MobileVerify'

import OneKeyPayment from '@/views/onekey/PayOnline'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/trans/accounts',
			name: 'TransAccounts',
			component: TransAccounts
		},
		{
			path: '/trans/accounts/help',
			name: 'TransAccountsHelp',
			component: TransAccounts
		},
		{
			path: '/trans/qr',
			name: 'TransQr',
			component: TransQr
		},
		{
			path: '/trans/fillin',
			name: 'TransFillIn',
			component: TransFillIn
		},
		{
			path: '/trans/edit',
			name: 'TransEdit',
			component: TransEdit
		},
		{
			path: '/trans/:id',
			name: 'TransList',
			component: TransList
		},
		{
			path: '/message/show/:id',
			name: 'MessageShow',
			component: MessageShow
		},
		{
			path: '/orders/create/customer',
			name: 'OrderNew',
			component: OrderNew
		},
		{
			path: '/orders/create/product',
			name: 'OrderNewPkg',
			component: OrderNewPkg
		},
		{
			path: '/orders',
			name: 'ManageOrderList',
			component: ManageOrderList
		},
		{
			path: '/orders/:id/success',
			name: 'OrderNewSuccess',
			component: OrderNewSuccess
		},
		{
			path: '/orders/:id',
			name: 'OrderDetail',
			component: OrderDetail
		},
		{
			path: '/my/orders',
			name: 'MyOrderList',
			component: MyOrderList
		},
		{
			path: '/my/orders/:id',
			name: 'OrderFullDetail',
			component: OrderFullDetail
		},
		{
			path: '/orders/confirm/:id',
			name: 'OrderConfirm',
			component: OrderConfirm
		},
		{
			path: '/pay/ways/:id',
			name: 'OrderPay',
			component: Payways
		},
		{
			path: '/pay/ways/:id',
			name: 'Payways',
			component: Payways
		},
		{
			path: '/pay/online/:id',
			name: 'PayOnline',
			component: PayOnline
		},
		{
			path: '/pay/split/:id',
			name: 'PaySplit',
			component: PayOnline
		},
		{
			path: '/pay/qr/:name/:id',
			name: 'PayQr',
			component: PayQr
		},
		{
			path: '/orders/pay/success/:id',
			name: 'OrderPaySuccess',
			component: OrderPaySuccess
		},
		{
			path: '/orders/error/:id',
			name: 'OrderPayFailed',
			component: OrderContract
		},
		{
			path: '/orders/complete/:id',
			name: 'OrderPurchaseDone',
			component: OrderPurchaseDone
		},
		// {
		// 	path: '/orders/service/:id',
		// 	name: 'OrderServiceDone',
		// 	component: OrderServiceDone
		// },
		{
			path: '/orders/service/complete/:id',
			name: 'OrderServiceDone',
			component: OrderServiceComplete
		},
		{
			path: '/orders/select/teacher/:id',
			name: 'OrderSelectTeacher',
			component: OrderSelectTeacher
		},
		{
			path: '/noservice/order/done',
			name: 'NoQyServiceOrderDone',
			component: NoQyServiceOrderDone
		},
		{
			path: '/orders/verify/:id',
			name: 'MobileVerify',
			component: MobileVerify
		},
		{
			path: '/onekey/payment/:id',
			name: 'OneKeyPayment',
			component: OneKeyPayment
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js